// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getRtcBotTypeById } from 'app/constants/enums/RtcBotType/main';

/* eslint-disable max-len */
export const INTERCEPTOR = getRtcBotTypeById('Interceptor');
export const TEACHER_RECRUITMENT = getRtcBotTypeById('TeacherRecruitment');
export const TEST_CALL = getRtcBotTypeById('TestCall');
/* eslint-enable max-len */
